/**
 * Plugin that adds custom CLEX functionality and buttons
 */
// Example usage: $('.selector').froalaEditor('clex.publicMethod');

// Add an option for your plugin.
$.FroalaEditor.DEFAULTS = $.extend($.FroalaEditor.DEFAULTS, {
  myOption: false
});


/**
 * CLEX_ConvertImageToMicroNote - converts an image to a MicroNote
 */

$.FroalaEditor.DefineIcon('CLEX_ConvertImageToMicroNote', {NAME: 'object-group'});
$.FroalaEditor.RegisterCommand('CLEX_ConvertImageToMicroNote', {
  title: 'Convert Image to Micro Note',
  focus: true,
  undo: true,
  refreshAfterCallback: true,

  callback() {
    console.log('CLEX_ConvertImageToMicroNote()')
    this.events.trigger('clex.convertImageToMicroNote'); // this event handles removing the image
  }
});


/**
 * CLEX_InsertDivider - marks boundaries that divide lecture notes into micro notes
 */

$.FroalaEditor.DefineIcon('CLEX_InsertDivider', {NAME: 'minus'});
$.FroalaEditor.RegisterCommand('CLEX_InsertDivider', {
  title: 'Insert Lecture Note Divider',
  focus: true,
  undo: true,
  refreshAfterCallback: true,

  callback() {
    console.log('CLEX_InsertDivider()')
    console.log(`selection:`);
    console.log(this.selection.element());
    this.html.insert('<hr is="divider">');
  }
});
$.FroalaEditor.RegisterShortcut(77, 'CLEX_InsertDivider', '', 'm', true, false);
$.FroalaEditor.RegisterShortcut(189, '', '', '-', true, false);


/**
 * CLEX_Keyword - marks a keyword
 */

$.FroalaEditor.DefineIcon('CLEX_Keyword', {NAME: 'key'});
$.FroalaEditor.RegisterCommand('CLEX_Keyword', {
  title: 'Keyword',
  focus: true,
  undo: true,
  refreshAfterCallback: true,

  callback(buttonName) {
    const elem = this.selection.element();
    const selectionText = this.selection.text().trim();

    // pad start/end are for replacing the white space accidentally selected at the start/end of the keyword
    const padStart = this.selection.text().startsWith(' ');
    const padEnd = this.selection.text().endsWith(' ');

    let isActive = isWithinTag('keyword', elem);
    // console.log('CLEX_Keyword()')
    // console.log(`selection: ${selectionText}. isActive = ${isActive}`);

    if(isActive) {
      // remove the tag by unwrapping it
      $(elem).closest('keyword').contents().unwrap();
    } else {
      // wrap it
      if( !selectionText) return;
      // this.html.insert('<keyword>' +this.selection.get()+ '</keyword>');
      
      this.html.insert((padStart ? ' ' : '') + '<keyword>' + selectionText + '</keyword>' + (padEnd ? ' ' : '')); // this also clears other formatting
    }
  },

  refresh($btn) {
    const elem = this.selection.element();
    let isActive = isWithinTag('keyword', elem);
    $btn.toggleClass('fr-active', isActive);
  },

});
$.FroalaEditor.RegisterShortcut(75, 'CLEX_Keyword', '', 'k', true, false);



/**
 * Helper function to determine if element is of type tagName,
 * or has an ancestor of type tagName
 */

const isWithinTag = (tagName, elem) => {
  return $(elem).closest(tagName).length > 0;
}








// Below here is left as an example

// // Define the plugin.
// // The editor parameter is the current instance.
// $.FroalaEditor.PLUGINS.clex = (editor) => {

//   // Private variable visible only inside the plugin scope.
//   var private_var = 'My awesome plugin';

//   // Private method that is visible only inside plugin scope.
//   function _privateMethod () {
//     console.log (private_var);
//   }

//   // Public method that is visible in the instance scope.
//   function publicMethod () {
//     console.log (_privateMethod());
//   }

//   // The start point for your plugin.
//   function _init () {
//     // You can access any option from documentation or your custom options.
//     // console.log (editor.opts.myOption)

//     // Call any method from documentation.
//     // editor.methodName(params);

//     // You can listen to any event from documentation.
//     // editor.events.add('contentChanged', function (params) {});
//   }

//   // Expose public methods. If _init is not public then the plugin won't be initialized.
//   // Public method can be accessed through the editor API:
//   // $('.selector').froalaEditor('clex.publicMethod');
//   return {
//     _init: _init,
//     publicMethod: publicMethod
//   }
// }



// WEBPACK FOOTER //
// ./src/components/froala-editor/plugins/clex.js